import React from 'react';
import styles from '../style.module.scss';

const t = {
  meters: 'm',
};

const MaxHeight = ({ cellData }) => {
  return (
    <div className={styles.rightCell}>
      {cellData && cellData > 0 ? (
        <span className={styles.cellRelative}>
          {cellData} {t.meters}
        </span>
      ) : null}
    </div>
  );
};

export default MaxHeight;
